export const ADD_MODULE = 'ADD_MODULE';

export default () => {};
